import React, { useEffect, useState } from "react";
import { IParentSize } from "../../../../types";
import { useRealtimeValues } from "../../../../system/websocketClient";
import CastingFloor from "../hmi/castingFloor";
import SuperHeat from "../hmi/superHeat";
import RightPane from "../hmi/rightPane";
import { variables } from "../hmi/types";
import SpeedStrandComponent from "./speedStrandComponent";


interface IProps {
  parentSize: IParentSize;
}

const HmiLab = ({parentSize}: IProps) => {
  const [ realtimeDispatch, realtime ] = useRealtimeValues();
  const [retry, setRetry] = useState(0);

  useEffect(() => {

    realtimeDispatch({
      tags: variables,
      interval: 1000
    }, () => setRetry(prevState => (prevState + 1) % 100));
  }, [realtimeDispatch, retry, setRetry]);

  const width = ((parentSize.width - 16) / 5) - 16;

  return (
    <div className="display-grid gap-1" style={{ ...parentSize, gridTemplateRows: "auto auto 1fr", overflowY: "auto" }}>
      <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
        <CastingFloor realtime={realtime}/>
        <SuperHeat realtime={realtime} parentSize={{ height: 300, width: (parentSize.width - 32) / 2 }}/>
        <RightPane realtime={realtime} />
      </div>
      <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr" }}>
        <SpeedStrandComponent title="Strand 1" realtime={realtime} strandCode="STR01" width={width}/>
        <SpeedStrandComponent title="Strand 2" realtime={realtime} strandCode="STR02" width={width}/>
        <SpeedStrandComponent title="Strand 3" realtime={realtime} strandCode="STR03" width={width}/>
        <SpeedStrandComponent title="Strand 4" realtime={realtime} strandCode="STR04" width={width}/>
        <SpeedStrandComponent title="Strand 5" realtime={realtime} strandCode="STR05" width={width}/>
      </div>
    </div>
  );
};

export default HmiLab;
